<template>
    <div v-if="allData.length" class="report-career" dir="rtl">
        <!-- <div style="margin-top: 200px;" v-if="pathLogo == m "></div> -->

        <header>

            <div style="padding-top: 20px" class="md-layout-item md-size-100 mt-25">
                <h3 style="margin-bottom: 15px ; font-weight: bold" class="text-center">{{ fullName }}</h3>
                <h4 style="margin-top: 0px; " class="text-center">
                    {{ shortName }}
                </h4>
                <h4 class="text-center">
                    كشف بأسماء الموظفين المرشحين للترقية للدرجة {{ Grade }} و
                    {{ AboveGrade }} الذين انهو الحد الأدنى في درجاتهم الوظيفية عن شهر
                    {{ monthDate }}
                </h4>
                <div class="text-center" style="direction: ltr; display: flex"></div>
            </div>
        </header>

        <div class="md-layout">
            <div class="md-layout-item">
                <md-card>
                    <md-card-header style="margin-bottom: 30px;" class="md-card-header-text md-card-header-green">
                        <div class="card-text">
                            <h4 class="title">كشف بأسماء الموظفين المرشحين للترقية
                            </h4>
                        </div>
                    </md-card-header>

                    <div style="margin-top: 10px; margin-bottom: 35px; " class="marginTop">
                        <md-card-content>


                            <md-table class="paginated-table table-striped table-hover mt-25">
                                <md-table-row>


                                    <md-table-cell>ر.م</md-table-cell>

                                    <md-table-cell class="w-160">الرقم الوظيفي</md-table-cell>

                                    <md-table-cell class="w-160">الإسم</md-table-cell>

                                    <md-table-cell class="w-100">الوضع الوظيفي</md-table-cell>

                                    <md-table-cell class="w-100">تاريخ التوظيف</md-table-cell>

                                    <md-table-cell class="w-100">المؤهل العلمي</md-table-cell>

                                    <md-table-cell>التخصص</md-table-cell>

                                    <md-table-cell class="w-100">الدرجة الحالية</md-table-cell>

                                    <md-table-cell class="w-160">تاريخ الحصول عليها</md-table-cell>

                                    <md-table-cell class="w-100">شهر العلاوة</md-table-cell>

                                    <md-table-cell class="w-160">الدرجة المرقة لها</md-table-cell>

                                    <md-table-cell class="w-100">تاريخ استحقاقها</md-table-cell>


                                    <md-table-cell class="w-160">تقدير تقارير الكفاءة السنوية لسنة {{
                                        allData[0].numberOfTheYear }}</md-table-cell>

                                    <md-table-cell class="w-160">تقدير تقارير الكفاءة السنوية لسنة {{
                                        allData[0].numberOfTheYearTwo }}</md-table-cell>

                                    <md-table-cell class="w-160">تقدير تقارير الكفاءة السنوية لسنة {{
                                        allData[0].numberOfTheYearThree }}</md-table-cell>


                                </md-table-row>
                                <md-table-row v-for="(item, i) in allData" :key="i">

                                    <md-table-cell md-label="الصنف">{{
                                        i + 1
                                    }}</md-table-cell>

                                    <md-table-cell md-label="الصنف">{{
                                        item.jobNumber
                                    }}</md-table-cell>


                                    <md-table-cell md-label="الصنف">{{
                                        item.employeeName
                                    }}</md-table-cell>


                                    <md-table-cell md-label="الصنف">{{
                                        item.jobType
                                    }}</md-table-cell>

                                    <md-table-cell md-label="الصنف">{{
                                        item.jobDate == null ? "" : convert(item.jobDate)
                                    }}</md-table-cell>

                                    <md-table-cell md-label="الصنف">{{
                                        item.scientificAppointment
                                    }}</md-table-cell>


                                    <md-table-cell md-label="الصنف">{{
                                        item.specialization
                                    }}</md-table-cell>


                                    <md-table-cell md-label="الصنف">{{
                                        item.currentGrade
                                    }}</md-table-cell>

                                    <md-table-cell md-label="الصنف">{{
                                        item.lastGradeUpdate == null ? "" : convert(item.lastGradeUpdate)
                                    }}</md-table-cell>


                                    <md-table-cell md-label="الصنف">{{
                                        item.monthName
                                    }}</md-table-cell>

                                    <md-table-cell md-label="الصنف">{{
                                        item.dueGrade
                                    }}</md-table-cell>

                                    <md-table-cell md-label="الصنف">{{
                                        item.monthDate == null ? "" : convertDay(item.monthDate)
                                    }}</md-table-cell>

                                  
                                    <md-table-cell md-label="الصنف">{{
                                        item.efficiency
                                    }}</md-table-cell>

                                    <md-table-cell md-label="الصنف">{{
                                        item.efficiencyTwo
                                    }}</md-table-cell>

                                    <md-table-cell md-label="الصنف">{{
                                        item.efficiencyThree
                                    }}</md-table-cell>



                                </md-table-row>
                            </md-table>

                        </md-card-content>
                    </div>


                    <div style="margin-bottom: 30px;" class=" md-layout mt-25 text-center last-footer">
                        <div class="md-layout-item md-size-50">
                            <p style="font-weight: bold">إعداد</p>
                            <p style="font-weight: bold">رئيس قسم شؤون الموظفين</p>
                        </div>

                        <div class="md-layout-item md-size-50">
                            <p style="font-weight: bold">إعتماد</p>
                            <p style="font-weight: bold">مدير إدارة الشؤون اللإدارية</p>
                        </div>
                    </div>
                </md-card>
            </div>

        </div>



    </div>
</template>
  
<script>
import env from "../../../env";

export default {
    mounted() { },
    props: [
        "allData",
        "fullName",
        "shortName",
        "Grade",
        "AboveGrade",
        "monthDate",
    ],

    data() {
        return {
            m: env.mTop(),

        };
    },

    methods: {

        convertDay(event) {
            try {
                let d = new Date(event);
                if (isNaN(d.getFullYear()) === true) {
                    return "-";
                }
                return (
                    d.getFullYear() + "-" + (d.getMonth() + 1) 

                    // +
                    // " , "
                    // +
                    // d.getHours() +
                    // ":" +
                    // d.getMinutes()
                );
            } catch (error) { }
        },
    
        convert(event) {
            try {
                let d = new Date(event);
                if (isNaN(d.getFullYear()) === true) {
                    return "-";
                }
                return (
                    d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

                    // +
                    // " , "
                    // +
                    // d.getHours() +
                    // ":" +
                    // d.getMinutes()
                );
            } catch (error) { }
        },
    },
};
</script>
  
<style lang="scss" scoped>@import "../../assets/css/career-promotion";</style>
  